var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiDriven = function SvgAiDriven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.852 2.842 27.8 0l-1.052 2.842a7.3 7.3 0 0 1-4.306 4.307L19.6 8.2l2.842 1.052a7.3 7.3 0 0 1 4.306 4.306L27.8 16.4l1.052-2.842a7.3 7.3 0 0 1 4.306-4.306L36 8.2 33.158 7.15a7.3 7.3 0 0 1-4.306-4.307M15.57 13.183 13.8 8.4l-1.77 4.783a12.26 12.26 0 0 1-7.247 7.247L0 22.2l4.783 1.77a12.26 12.26 0 0 1 7.247 7.247L13.8 36l1.77-4.783a12.26 12.26 0 0 1 7.247-7.247L27.6 22.2l-4.783-1.77a12.26 12.26 0 0 1-7.247-7.247"
  })));
};
export default SvgAiDriven;